// extracted by mini-css-extract-plugin
export default {"container":"Main_container__9tFrY","main":"Main_main__F2ek1","form-section":"Main_form-section__s8oS5","list-section":"Main_list-section__TzX2M"};